import React, { FC } from 'react';
import { useLocation } from 'react-router';
import classNames from 'classnames';

import { ContextNamespace } from 'app/constants/Context';
import { MatchType } from 'app/lib/betting/betting-entities';
import { getTruncatedNumber } from 'app/lib/formatters';
import { ROUTE_PATH } from 'app/lib/routing/constants';

import { MatchRowStatus } from '../../../../constants';
import { getDataGaEventByNamespace } from '../../../../utils/data-ga-event-by-namespace';
import ExpansionButton from '../../../ExpansionButton';
import MatchCenterLink from '../../../MatchCenterLink';

import styles from './MatchLineButtons.module.scss';

// ---

type LineButtonsProps = {
  namespace: ContextNamespace;
  matchId: number;
  betCount: number;
  matchType: MatchType;
  expansionState: MatchRowStatus;
  onClick: VoidFunction;
};

const LineButtons: FC<LineButtonsProps> = ({
  namespace,
  matchId,
  betCount,
  matchType,
  expansionState,
  onClick,
}) => {
  const { pathname } = useLocation();
  const isFavoritePage = pathname === ROUTE_PATH.FAVORITES;
  const _classNames = classNames(styles.lineButtons, {
    [styles.singleEventButtons]: matchType === MatchType.OUTRIGHT,
  });
  const dataGaValues = expansionState !== MatchRowStatus.COLLAPSED
    ? { ['data-ga-event']: getDataGaEventByNamespace(namespace, 'expandBidsGroups') }
    : undefined;

  return (
    <div className={_classNames}>
      <MatchCenterLink matchId={matchId}
                       className={styles.betsCount}>
        {`+${getTruncatedNumber(betCount, { accuracy: { thousands: 1 } })}`}
      </MatchCenterLink>

      {(Boolean(betCount) && !isFavoritePage) && (
        <ExpansionButton expansionState={expansionState}
                         dataGaValues={dataGaValues}
                         onClick={onClick} />
      )}
    </div>
  );
};

export default LineButtons;
